export enum AxxessIntelligenceThumbEnum {
    None = 0,
    Up = 1,
    Down = 2
}

export enum AxxessIntelligencePageEnum {
    helpCenter = "HelpCenter",
    physician = "Physician",
    report = "Report",
    page = "Page"
}
